import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';;
import { Router } from '@angular/router';
import { ContractThemaNego } from '@core/models/contract-thema-nego.model';
import { BaseService } from '@core/services/base/base.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContractGeneralInformationsService extends BaseService {
  public generalInformations = '/contract-informations';

  constructor(private httpService: HttpClient, private snackBar: MatSnackBar, private router: Router) {
    super();
  }

  public edit(informations): Observable<any> {
    let url = environment.contract_microservice_api_base_url + this.generalInformations;

    url += '/' + informations.id;

    return new Observable(observer => {
      this.httpService.put(url, informations).subscribe(
        response => {
          if (response && response['data']) {
            observer.next(new ContractThemaNego(response['data']));
          } else {
            observer.next(response);
          }
          observer.complete(); // ✅ très important !
        },
        error => {
          observer.error(this.catchError(error));
          observer.complete(); // on peut ou non compléter après une erreur
        }
      );
    });
  }

  public catchError(error: any, routeRedirect: string = null): any {
    this.snackBar.open(error.error?.data?.msg ? error.error?.data?.msg : 'Une erreur est survenue', null, {
      duration: 2000,
      verticalPosition: 'top',
    });

    if (routeRedirect) {
      this.router.navigate([routeRedirect]);
    }

    return error;
  }
}
